import { Divider } from "@kunduz/ui";
import React from "react";

export const DividerComponent = (props: Props) => {
  const { bottom, color, middleText, size, top } = props;

  return (
    <Divider
      bottom={bottom}
      color={color}
      middleText={middleText}
      size={size}
      top={top}
    />
  );
};

interface Props {
  top?: number;
  bottom?: number;
  size?: number;
  color?: string;
  middleText?: string;
}
